import React, { useState } from 'react';
import { Container, Paper, Grid, Button, Box, Typography } from '@mui/material';

function Calculadora() {
  const [expressao, setExpressao] = useState('');
  const [historico, setHistorico] = useState('');

  // Adiciona números
  const handleClick = (valor) => {
    // Impede múltiplos operadores seguidos
    const ultimo = expressao.slice(-1);
    if (['+', '-', '*', '/', '.'].includes(valor) && ['+', '-', '*', '/', '.'].includes(ultimo)) {
      return;
    }
    setExpressao((prev) => prev + valor);
  };

  // Limpa tudo
  const limpar = () => {
    setExpressao('');
    setHistorico('');
  };

  // Apaga último dígito
  const apagar = () => {
    setExpressao((prev) => prev.slice(0, -1));
  };

  // Calcula o resultado
  const calcular = () => {
    if (!expressao) return;

    try {
      // Substitui o 'x' visual por '*' para o cálculo
      const expressaoSegura = expressao.replace(/x/g, '*');
      
      // eslint-disable-next-line no-new-func
      const resultado = new Function('return ' + expressaoSegura)();
      
      // Arredonda para evitar dízimas gigantes
      const resultadoFormatado = String(Math.round(resultado * 100000000) / 100000000);
      
      setHistorico(expressao + ' =');
      setExpressao(resultadoFormatado);
    } catch (error) {
      setExpressao('Erro');
      setTimeout(() => setExpressao(''), 1000);
    }
  };

  const botoes = [
    '7', '8', '9', '/',
    '4', '5', '6', '*',
    '1', '2', '3', '-',
    '.', '0', '+', '='
  ];

  return (
    <Container maxWidth="xs" sx={{ mt: 4 }}>
      <Paper 
        elevation={10} 
        sx={{ 
          p: 3, 
          borderRadius: 4, 
          bgcolor: '#212121', 
          color: 'white'
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center', color: '#90caf9' }}>
          Calculadora Rápida
        </Typography>

        {/* Visor */}
        <Box 
          sx={{ 
            bgcolor: '#424242', 
            borderRadius: 2, 
            p: 2, 
            mb: 2, 
            textAlign: 'right', 
            minHeight: '85px',
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center'
          }}
        >
          <Typography variant="caption" sx={{ color: '#aaa', minHeight: '20px' }}>
            {historico}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 'bold', letterSpacing: 1 }}>
            {expressao || '0'}
          </Typography>
        </Box>

        {/* Botões de Ação */}
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={6}>
            <Button 
              fullWidth 
              variant="contained" 
              color="error" 
              onClick={limpar}
              sx={{ height: 50, fontWeight: 'bold' }}
            >
              LIMPAR
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button 
              fullWidth 
              variant="contained" 
              color="warning" 
              onClick={apagar}
              sx={{ height: 50, fontWeight: 'bold' }}
            >
              APAGAR
            </Button>
          </Grid>
        </Grid>

        {/* Teclado Numérico */}
        <Grid container spacing={1}>
          {botoes.map((btn) => (
            <Grid item xs={3} key={btn}>
              <Button 
                fullWidth 
                variant="contained" 
                onClick={() => btn === '=' ? calcular() : handleClick(btn)}
                sx={{ 
                  height: 60, 
                  fontSize: '1.25rem',
                  bgcolor: ['/', '*', '-', '+', '='].includes(btn) ? '#ff9800' : '#616161',
                  '&:hover': { bgcolor: ['/', '*', '-', '+', '='].includes(btn) ? '#f57c00' : '#757575' }
                }}
              >
                {btn}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
}

export default Calculadora;